(function () {
  const COLOR_OPTION_NAME = "Couleur"; // Mets le nom EXACT de l’option Shopify
  const MEDIA_SELECTOR = "[data-color]"; // On filtre sur data-color injecté par Liquid

  function normalize(s) {
    return (s || "").toString().trim().toLowerCase();
  }

  function getSelectedColorFromForm() {
    const form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector("product-form form") ||
      document.querySelector("form");

    if (!form) return null;

    const radio = form.querySelector(
      `input[type="radio"][name="options[${CSS.escape(COLOR_OPTION_NAME)}]"]:checked`
    );
    if (radio?.value) return radio.value.trim();

    const select = form.querySelector(
      `select[name="options[${CSS.escape(COLOR_OPTION_NAME)}]"]`
    );
    if (select?.value) return select.value.trim();

    // fallback
    const checkedAny = Array.from(form.querySelectorAll('input[type="radio"][name^="options["]:checked'));
    for (const r of checkedAny) {
      const name = r.getAttribute("name") || "";
      const inside = name.match(/^options\[(.+)\]$/i);
      const optionName = inside ? inside[1] : "";
      if (normalize(optionName) === normalize(COLOR_OPTION_NAME)) return r.value.trim();
    }

    const selects = Array.from(form.querySelectorAll('select[name^="options["]'));
    for (const s of selects) {
      const name = s.getAttribute("name") || "";
      const inside = name.match(/^options\[(.+)\]$/i);
      const optionName = inside ? inside[1] : "";
      if (normalize(optionName) === normalize(COLOR_OPTION_NAME)) return (s.value || "").trim();
    }

    return null;
  }

  function applyFilter() {
    const selectedColor = getSelectedColorFromForm();
    if (!selectedColor) return;

    const sel = normalize(selectedColor);
    const items = document.querySelectorAll(MEDIA_SELECTOR);

    // Si on ne trouve aucun item data-color => Liquid pas au bon endroit
    if (!items.length) return;

    items.forEach((el) => {
      const c = normalize(el.getAttribute("data-color"));
      const show = (c === "" || c === "all" || c === sel);
      el.style.display = show ? "" : "none";
    });
  }

  document.addEventListener("change", (e) => {
    const t = e.target;
    if (!t) return;
    if (t.matches('input[type="radio"][name^="options["]') || t.matches('select[name^="options["]')) {
      setTimeout(applyFilter, 80);
    }
  });

  document.addEventListener("variant:change", () => setTimeout(applyFilter, 80));
  window.addEventListener("DOMContentLoaded", () => setTimeout(applyFilter, 150));
})();
